/**
 * EnviarPedidoDialog - Modal de escolha do método de envio do pedido de compra (extraído de Compras.jsx).
 */
import React from 'react';
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter } from '../ui/dialog';
import { Button } from '../ui/button';
import { MessageCircle, Send, FileText, CheckCircle } from 'lucide-react';

const EnviarPedidoDialog = ({ pedido, onClose, onConfirmarEnvio }) => {
  return (
    <Dialog open={!!pedido} onOpenChange={() => onClose()}>
      <DialogContent className="max-w-md">
        <DialogHeader>
          <DialogTitle className="flex items-center gap-2">
            <Send className="w-5 h-5 text-blue-600" />
            Enviar Pedido de Compra
          </DialogTitle>
        </DialogHeader>

        {pedido && (
          <div className="space-y-4 mt-4">
            <div className="p-3 bg-gray-50 rounded-lg">
              <p className="text-sm text-gray-600">
                Pedido: <span className="font-mono font-medium text-purple-600">{pedido.numero}</span>
              </p>
              <p className="text-sm text-gray-600">
                Fornecedor: <span className="font-medium">{pedido.fornecedor_nome}</span>
              </p>
              <p className="text-sm text-gray-600">
                Valor Total: <span className="font-medium text-green-600">
                  {pedido.total?.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })}
                </span>
              </p>
            </div>

            <div className="space-y-2">
              {pedido.fornecedor_telefone && (
                <Button
                  className="w-full justify-start"
                  variant="outline"
                  onClick={() => onConfirmarEnvio('whatsapp')}
                  data-testid="btn-enviar-pedido-whatsapp"
                >
                  <MessageCircle className="w-4 h-4 mr-2 text-green-600" />
                  Enviar via WhatsApp
                </Button>
              )}
              <Button
                className="w-full justify-start"
                variant="outline"
                onClick={() => onConfirmarEnvio('pdf')}
                data-testid="btn-enviar-pedido-pdf"
              >
                <FileText className="w-4 h-4 mr-2 text-red-600" />
                Baixar PDF para enviar manualmente
              </Button>
            </div>

            <div className="border-t pt-4">
              <Button
                className="w-full"
                onClick={() => onConfirmarEnvio('status')}
                data-testid="btn-enviar-pedido-status"
              >
                <CheckCircle className="w-4 h-4 mr-2" />
                Apenas marcar como enviado
              </Button>
              <p className="text-xs text-gray-500 text-center mt-2">
                O status será alterado para &quot;Enviado&quot;
              </p>
            </div>
          </div>
        )}

        <DialogFooter>
          <Button variant="outline" onClick={() => onClose()}>
            Cancelar
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};

export default EnviarPedidoDialog;
